module.exports = __webpack_public_path__ + "static/media/logo-autralis-white.1925bc27.svg";